import { createAction } from 'redux-actions';
export const SAVE_SEAT_SERVICES = 'SAVE_SEAT_SERVICES';
export const CONFIRM_RECOMMENDED_SEATS = 'CONFIRM_RECOMMENDED_SEATS';
export const saveSeatServices = createAction(SAVE_SEAT_SERVICES);
export const confirmRecommendedSeats = createAction(CONFIRM_RECOMMENDED_SEATS);
